const error = () => ({
  onErrorPageLoad: (errorCode: string ) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/error/${errorCode}`,
    //   title: `PFM - Online Investments - Error - ${errorCode}`,
    //   cd64: errorCode
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments - Error',
    //   label: errorCode
    // })
  }
});
export default error;